module.exports = __webpack_public_path__ + "img/40_38_051_050.a4e1c91b.jpg";